import React, { useCallback, useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { formatDate } from "../../services/api.service";
import usePagination from "../../custom/Utils/UsePaginationUtils";
import useFetchData from "../../custom/Utils/UseFetchDataUtils";
import { listPageData } from "./SparePartRequestFile";

const breadcrumbItems = [];

const SparePartRequestList = () => {
  const navigate = useNavigate();
  const [exportData, setExportData] = useState([]);

  const { payload, endpoint, searchfields, exportFileName } = listPageData();
  const initialPayload = useMemo(() => payload, []);
  // pagination
  const {
    page,
    pageSize,
    nextPage,
    previousPage,
    lastPage,
    firstPage,
    handlePageSizeChange,
    setPage,
  } = usePagination();

  // fetch data using the provided payload, page, and page size
  const { data, isLoading, setSearchKeyword, totalCount } = useFetchData(
    initialPayload,
    page,
    pageSize,
    endpoint,
    searchfields
  );

  const handleClickAdd = () => {
    navigate("/spare-part-requests-create");
  };

  const handleEditClick = (id) => {
    navigate(`/spare-part-requests-create/${id}`);
  };
  const handleViewClick = (id) => {
    navigate(`/spare-part-requests-view/${id}`);
  };

  const handlePageSizeChangeWrapper = useCallback(
    (newSize) => {
      handlePageSizeChange(newSize, totalCount);
    },
    [totalCount]
  );

  const getStatus = (row) => {
    console.log(row);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },

      {
        Header: "SPARE PART REQ. NO",
        accessor: (row) =>
          row?.spare_part_request_no ? row?.spare_part_request_no : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "JOB CARD",
        accessor: (row) =>
          row?.job_card && row?.job_card ? row?.job_card.job_card_no : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "SPARE PART",
        accessor: (row) => (row?.spare && row?.spare ? row?.spare.name : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "QUANTITY",
        accessor: (row) =>
          row?.quantity && row?.quantity ? row?.quantity : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      // {
      //   Header: "ISSUE QTY",
      //   accessor: (row) =>
      //     row?.issue_qty && row?.issue_qty ? row?.issue_qty : "-",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      // },

      {
        Header: "ISSUE QTY",
        accessor: (row) =>
          row?.issue_qty && row?.issue_qty ? row?.issue_qty : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "STATUS",
        accessor: (row) => (row?.status && row?.status ? row?.status : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "REQUESTED BY",
        accessor: (row) =>
          row?.requested_by_user && row?.requested_by_user?.first_name
            ? row?.requested_by_user?.first_name +
              " " +
              row?.requested_by_user?.last_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "REQUESTED AT",

        accessor: (row) =>
          row?.requested_at && row?.requested_at
            ? formatDate(row?.requested_at)
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "IS ACTIVE",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === false || value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px", display: "flex" }}>
            <div
              onClick={() => {
                handleEditClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-pencil font-size-18"></i>
              </Link>
            </div>

            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Spare Part Request List"
              breadcrumbItems={breadcrumbItems}
            />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Spare Part Requests
            </Button>
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isLoading={isLoading}
                onSearchInputData={setSearchKeyword}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChangeWrapper}
                nextToPage={nextPage}
                lastToPage={() => lastPage(totalCount)}
                previousToPage={previousPage}
                previousFirstToPage={firstPage}
                totalCount={totalCount}
                customPageSize={pageSize}
                exportData={exportData}
                exportFileName={exportFileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SparePartRequestList;
